// This wrap some global funtions that out of control in front-end project
// Don't give an implementation here, this work as a bridge to outside funtions

import { LogHelpers } from './logHelper';

// Don't expose this to the global
const log = new LogHelpers('globalHelpers');
const W = window as any;
export function disableWait() {
  if ((window as any).disableWait) {
    (window as any).disableWait();
  }
}

export function showWait() {
  if ((window as any).showWait) {
    (window as any).showWait();
  }
}

export const S4Y_GLOBAL: {
  locale?: string;
  base?: string;
  baseUrl?: string;
  principalKey?: string;
  isAuthenticated: boolean;
  projectpath?: string;
  projectICC: string;
  messages: () => { [key: string]: string };
} = {
  locale: W.S4Y_GLOBAL?.locale,
  base: W.S4Y_GLOBAL?.base,
  baseUrl: W.S4Y_GLOBAL?.baseUrl,
  principalKey: W.S4Y_GLOBAL?.principalKey,
  isAuthenticated:
    W.S4Y_GLOBAL?.principalKey &&
    typeof +W.S4Y_GLOBAL.principalKey === 'number' &&
    +W.S4Y_GLOBAL.principalKey > 0,
  projectpath: W.S4Y_GLOBAL?.projectpath,
  projectICC: W.S4Y_GLOBAL?.projectICC,
  messages: () => W.S4Y_GLOBAL?.messages,
};

console.log(S4Y_GLOBAL);

export const SystemJS = W.SystemJS;

export const S4YBase = {
  isChrome: () => {
    const isChrome = W.chrome;
    if (!isChrome) return false;
    return true;
  },
};

export const getI18nValue = (key: string) => {
  try {
    const messages = S4Y_GLOBAL.messages();
    log.log(messages);
    if (messages) {
      if (Object.keys(messages).some((k) => k === key)) {
        return messages[key];
      } else {
        return key;
      }
    } else {
      return key;
    }
  } catch (error) {
    return key;
  }
};
